import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
//import PropTypes from 'prop-types'
import Radium from 'radium'

import { connect } from 'react-redux'

import {} from './../../../actions'

import TEAlert from './../../../component/Popup/TEAlert'
import Navbar from './../Navbar'
import SideNavbar from './../SideNavbar'
import Footer from './../Footer'

import Welcome from './../../../pages/Admin/Welcome'
import Organizations from './../../../pages/Admin/Organizations'
import Organization from './../../../pages/Admin/Organization'
import User from './../../../pages/Admin/User'

import PrivateRoute from './../../../component/PrivateRoute'
import NotFound from './../../../pages/NotFound'

import { compareToLocalVersion } from './../../../helpers'

import styles from './styles'

class AdminContentWrapper extends Component {
	render() {
		const { history, location, appVersions, appVersionsLoaded } = this.props

		if (!appVersionsLoaded) {
			return null
		}

		const { behind } = compareToLocalVersion(appVersions.web.minimum)
		if (behind) {
			return (
				<TEAlert
					title="Major Version Update"
					message={`A newer version of the platform is available (v${
						appVersions.web.minimum
					}) and is required to continue using the platform. Press the okay button below to receive the most recent version. If you continue to see this prompt after many attempts, either clear your cache or contact technical support.`}
					onClick={() => window.location.reload(true)}
					visible
				/>
			)
		}

		return (
			<div className="portal-wrapper" style={styles.portalWrapper}>
				<SideNavbar location={location} />
				<div className="main-panel" style={styles.mainPanel}>
					<Navbar history={history} />
					<div className="portal-content-wrapper" style={styles.portalContentWrapper}>
						<Switch>
							<PrivateRoute
								path="/admin/welcome"
								component={Welcome}
								requiredUserType="admin"
							/>
							<PrivateRoute
								path="/admin/organizations/:orgUID/users/:uid"
								component={User}
								requiredUserType="admin"
							/>
							<PrivateRoute
								path="/admin/organizations/:uid"
								component={Organization}
								requiredUserType="admin"
							/>
							<PrivateRoute
								path="/admin/organizations"
								component={Organizations}
								requiredUserType="admin"
							/>

							<Route component={NotFound} />
						</Switch>
					</div>
					<Footer appVersions={appVersions} />
				</div>
			</div>
		)
	}
}

AdminContentWrapper.propTypes = {}

AdminContentWrapper.defaultProps = {}

const mapStateToProps = (state) => {
	const { appVersions, appVersionsLoaded } = state.Loading

	return {
		appVersions,
		appVersionsLoaded,
	}
}

export default connect(
	mapStateToProps,
	{}
)(Radium(AdminContentWrapper))
